export default function inlineImageResizePluginTrigger(evt, editor) {
    if (evt.eventType == 5 /* MouseUp */) {
        var domElement = evt.rawEvent.target;
        if (domElement != null && domElement.nodeName == 'IMG') {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=inlineImageResizePluginTrigger.js.map